import { useUpdateSearchParams } from "./useUpdateSearchParams";

type Props = {
  localTags: Array<string>;
  onReset: () => void;
  baseUrl: "/articles/conferencier/" | "/articles/actualite/";
};
export const Reset = ({ localTags, onReset, baseUrl }: Props) => {
  const { updateSearchParams } = useUpdateSearchParams(baseUrl);

  if (localTags.length !== 0)
    return (
      <p
        className="text-base underline cursor-pointer"
        onClick={() => {
          updateSearchParams({
            tags: [],
            page: undefined,
          });
          onReset();
        }}
      >
        Réinitialiser
      </p>
    );

  return null;
};
